var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImages(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 16,
    viewBox: "0 0 21 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.2353 2.24995V13.75C20.2353 14.99 19.2134 16 17.9588 16H2.27646C2.17531 16 2.07416 15.9899 1.98301 15.9798C0.920737 15.85 0.0911474 14.99 0.0101892 13.93C-1.17206e-08 13.8699 0 13.8098 0 13.75V2.24995C0 1.00997 1.02189 -3.05176e-05 2.27646 -3.05176e-05H17.9588C19.2134 -3.05176e-05 20.2353 1.00997 20.2353 2.24995Z",
    fill: "#3EA3DC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.05829 4.94119C7.05829 6.11062 6.11022 7.05884 4.94074 7.05884C3.77107 7.05884 2.823 6.11062 2.823 4.94119C2.823 3.77177 3.77107 2.82355 4.94074 2.82355C6.11022 2.82355 7.05829 3.77177 7.05829 4.94119Z",
    fill: "#FFC659"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2357 10.9429V13.7513C20.2357 14.9905 19.2082 15.9999 17.9467 15.9999H2.17788C2.07617 15.9999 1.97446 15.9899 1.88281 15.9798L12.3615 5.68615C13.0533 5.00651 14.1926 5.00651 14.8845 5.68615L20.2357 10.9429Z",
    fill: "#658422"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1176 15.9999H2.25073C2.15028 15.9999 2.04982 15.9902 1.9593 15.9805C0.904304 15.8555 0.0804031 15.0273 0 14.0065L4.77285 9.43214C5.45618 8.77742 6.58146 8.77742 7.26479 9.43214L14.1176 15.9999Z",
    fill: "#84BA10"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImages);
export default __webpack_public_path__ + "static/media/images.ab1e2c23f3fd7f8f130fa8d9d60ab0ad.svg";
export { ForwardRef as ReactComponent };